<template>
	<div id="">

	</div>
</template>

<script>
import imageCropper from './com/imgCropper'
export default {
	components: {
		imageCropper
	},
	data() {
		return {

		}
	},
	mounted() {
		var lists = [];
		let calcList = idx => {
			if (idx < shows.length) {
				let s = shows[idx]
				var assetList = []
				getattentionAssetList({
					id: s.id
				}).then((res) => {
					if (res.code == 0) {
						assetList = res.data.assetVoList
						lists.push({
							id: s.id,
							name: s.name,
							assetList: assetList,
							isShow: true
						})
					}
				})
			}else{
				this.showList=lists
			}

		}
		if(shows.length>0){
			calcList(0)
		}

		
	}
}
</script>

<style>
.cropper-move {}
</style>
